import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/shared/shared.module";
import { DEMO } from "src/app/config/brand.config";

/**
 * One topic within a policy, as authored in `legal/data/*.data.ts`: a heading
 * (`name`) and its body (`content`, pre-built HTML — lists, paragraphs, the
 * contact block — so this component only has to loop and bind it).
 */
export interface LegalContentItem {
  id?: number;
  name: string;
  content: string;
}

/**
 * The shared shell for the four policy pages. They are the same page — a
 * title, a "last updated" line, an intro, and a run of headed sections —
 * differing only in which section list they are given, so the layout lives
 * here once and each route just hands over its data.
 */
@Component({
  selector: "app-legal-page",
  imports: [SharedModule, TranslateModule],
  templateUrl: "./legal-page.component.html",
  styleUrl: "./legal-page.component.scss",
})
export class LegalPageComponent {
  @Input({ required: true }) titleKey!: string;
  @Input() introKey?: string;
  @Input({ required: true }) sections: LegalContentItem[] = [];
  @Input() updatedKey = "LEGAL.UPDATED";

  readonly demo = DEMO;
}
